import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOperation = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "currentColor",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", { d: "m3.971 9.167 7.67 4.796a.707.707 0 0 0 .754 0l7.67-4.796a.69.69 0 0 0 .32-.575.675.675 0 0 0-.32-.576l-7.67-4.796a.707.707 0 0 0-.753 0l-7.67 4.796a.69.69 0 0 0-.32.576.676.676 0 0 0 .32.575Zm8.047-4.556 6.374 3.98-6.373 3.981-6.374-3.98 6.373-3.981Z" }),
		/* @__PURE__ */ _jsx("path", { d: "m19.31 11.44-7.293 4.557-7.294-4.556a.708.708 0 0 0-.933.224.675.675 0 0 0 .18.927l7.67 4.796a.706.706 0 0 0 .753 0l7.67-4.796a.676.676 0 0 0 .179-.926.708.708 0 0 0-.932-.225Z" }),
		/* @__PURE__ */ _jsx("path", { d: "m19.31 14.866-7.293 4.556-7.294-4.556a.708.708 0 0 0-.933.225.675.675 0 0 0 .18.926l7.67 4.796a.706.706 0 0 0 .753 0l7.67-4.796a.676.676 0 0 0 .179-.926.708.708 0 0 0-.932-.225Z" })
	] }), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", { d: "M3.5 3h17v18h-17z" })
	}) })]
});
export default SvgOperation;
